'use client';

import React from 'react';
import StaffDetailsContent from '@/app/dashboard/staff-settings/all-staff/components/staff-details-content';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setStaffDetails } from '@/store/reducers/drawer-content-slice';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';

import { GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function StaffDetailsDrawer(): React.JSX.Element | null {
  const { drawerState } = useAppSelector(getUi);

  const dispatch = useAppDispatch();

  return (
    <DrawerTemplate
      open={drawerState.STAFF_DETAILS}
      onClose={() => {
        dispatch(hideDrawerState(GeneralDrawer.STAFF_DETAILS));
        dispatch(setStaffDetails(null));
      }}
      title="Staff Details"
      width="830px"
    >
      <StaffDetailsContent />
    </DrawerTemplate>
  );
}
